import request from '@/util/request';
import qs from 'qs';

export const getList_ = (params, options) =>
  request.get('/api/parkTempCarBill/page', Object.assign({}, options, { params }));

export const getList = (params, options) =>
  request.get('/api/parkTempCarBill/page/v2', Object.assign({}, options, { params }));
  
export const getDetail = (params, options) =>
  request.get('/api/parkTempCarBill/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/parkTempCarBill/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/parkTempCarBill/submit', params, options);

export const update = (params, options) =>
  request.post('/api/parkTempCarBill/submit', params, options);

export const getCarOnlinePayLogByBillId = (params, options) =>
  request.get('/api/car/onLine/payLog/page', Object.assign({}, options, {
    params
  }));